import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API();

export default {

    getKierowcy(){
        return axios({
            method: 'get',
            url: URL + 'kierowcy/aktywni',
        });
    },

    getKierowca(id){
        return axios({
            method: 'get',
            url: URL + 'kierowcy/' + id,
        });
    },


    getPojazdy(){
        return axios({
            method: 'get',
            url: URL + 'pojazdy?page=0&size=9999',
        });
    },

    getPojazd(id){
        return axios({
            method: 'get',
            url: URL + 'pojazdy/' + id,
        });
    },

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/wynajemConfig/formularz/FormularzService.js